<template>
  <div>
    <shipblu-card class="p-4" :cardLoading="cardLoader">
      <div class="gap-4 justify-between sm:flex items-center">
        <div class="w-full" style="max-width: 500px;">
          <div class="pb-3 border-dashed gap-x-4 border-t-0 border-r-0 border-l-0 border-grey font-medium text-xl flex flex-wrap items-center border text-blue-100">
            <p>{{$t('Cash on the way')}}</p>
            <div class="flex justify-between w-36 flex-shrink-0 ml-auto text-lg">
              <p>{{('EGP')}}</p>
              <p>{{financials.cash_on_the_way.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</p>
            </div>
          </div>
          <div class="flex pt-5 text-grey-dark gap-x-2">
            <p class="text-gray">{{$t('Cash Collection Balance')}}</p>
            <div class="flex justify-between w-36 flex-shrink-0 ml-auto">
              <p class="text-gray">{{('EGP')}}</p>
              <p>{{financials.cash_collection_balance.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</p>
            </div>
          </div>
          <div class="flex pt-3 text-grey-dark">
            <p class="text-gray">{{$t('Refunds In Progress')}}</p>
            <div class="flex justify-between w-36 flex-shrink-0 ml-auto">
              <p class="text-gray">{{('EGP')}}</p>
              <p>{{financials.refunds_in_progress ? financials.refunds_in_progress.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0.00}}</p>
            </div>
          </div>
          <div class="flex pt-3 text-grey-dark">
            <p class="text-gray">{{$t('Service Fees Due')}}</p>
            <div class="flex justify-between w-36 flex-shrink-0 ml-auto">
              <p class="text-gray">{{('EGP')}}</p>
              <p>{{financials.service_fees_due.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</p>
            </div>
          </div>
          <div class="flex pt-3 text-grey-dark">
            <p class="text-gray">{{$t('Amounts On Hold')}}</p>
            <div class="flex justify-between w-36 flex-shrink-0 ml-auto">
              <p class="text-gray">{{('EGP')}}</p>
              <p>{{financials.amounts_on_hold.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</p>
            </div>
          </div>
        </div>
        <div class="sm:block hidden w-64">
          <img src="@/assets/images/pages/statment-pay.png" class="max-w-full" height="115">
        </div>
      </div>
      <div class="mt-6 items-center flex justify-between">
        <p>{{$t('Receive your cash for completed orders today!')}}</p>
        <div @click="instantPayoutModal = true" type="filled" class="cursor-pointer flex items-center leading-tight gap-1 bg-primary rounded-lg text-white p-3 font-semibold">
          <p class="material-symbols-outlined text-xl">bolt</p>
          <p>{{$t('Instant Payout')}}</p>
        </div>
      </div>
    </shipblu-card>
    <instant-payout-modal v-if="instantPayoutModal" @instantPayoutModal="instantPayoutModal = $event" />
  </div>
</template>

<script>
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import InstantPayoutModal from './InstantPayoutModal.vue'

export default {
  props: ['financials', 'cardLoader'],
  data () {
    return {
      instantPayoutModal: false
    }
  },
  components: {
    ShipbluCard,
    InstantPayoutModal
  }
}
</script>